"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const pointsAmountBannerInputs = [
  {
    name: "pointsSingular",
    type: "string",
    friendlyName: "Points singular form",
    defaultValue: "point",
    required: true,
  },
  {
    name: "pointsPlural",
    type: "string",
    friendlyName: "Points plural form",
    defaultValue: "points",
    required: true,
  },
  {
    name: "text",
    type: "string",
    friendlyName: "Text about expiration",
    defaultValue: "will expire in",
    required: true,
  },
  {
    name: "tooltipText",
    type: "string",
    friendlyName: "Tooltip text",
    defaultValue:
      "Points are valid for 2 calendar years. If unredeemed they are lost. Points earned today expire on December 31st Year",
    required: true,
  },
  {
    name: "url",
    type: "url",
    friendlyName: "Tooltip's link url",
    defaultValue: "#",
    required: true,
  },
  {
    name: "urlText",
    type: "string",
    friendlyName: "Tooltip's link label",
    defaultValue: "Explore",
    required: true,
  },
  {
    name: "hoursText",
    type: "string",
    friendlyName: "Hours label",
    defaultValue: "hours",
  },
  {
    name: "minutesText",
    type: "string",
    friendlyName: "Minutes label",
    defaultValue: "minutes",
  },
  {
    name: "daysSingularText",
    type: "string",
    friendlyName: "Single day label",
    defaultValue: "day",
  },
  {
    name: "daysPluralText",
    type: "string",
    friendlyName: "Plural days label",
    defaultValue: "days",
  },
  {
    name: "weeksSingularText",
    type: "string",
    friendlyName: "Singular week label",
    defaultValue: "week",
  },
  {
    name: "weeksPluralText",
    type: "string",
    friendlyName: "Plural weeks label",
    defaultValue: "weeks",
  },
  {
    name: "componentId",
    type: "string",
    defaultValue: "pointsamountbanner",
  },
  {
    name: "showDate",
    type: "boolean",
    friendlyName: "Show expiration as date",
    defaultValue: false,
  },
] as const satisfies Inputs;

export const PointsAmountBannerComponent: RegisteredComponent = {
  name: "PointsAmountBanner",
  component: dynamic(async () =>
    withValidation(
      pointsAmountBannerInputs,
      (await import("./PointsAmountBanner")).PointsAmountBanner,
      "PointsAmountBanner"
    )
  ),
  inputs: pointsAmountBannerInputs,
  requiresParent: {
    query: {
      "component.name": { $in: ["LoyaltyWrapper"] },
    },
    message: "'PointsAmountBanner' component can only be added inside a 'LoyaltyWrapper'",
  },
};
